const StatsCard = ({ title, description, image }) => {
  return (
    <div className="flex items-center justify-between w-full md:flex-1 self-stretch gap-6 font-inter">
      {/* LEFT */}
      <div className="flex flex-col gap-1 md:gap-2">
        <p className="text-white text-[28px] leading-[48px] md:text-[36px] md:leading-[48px] font-google font-semibold">
          {title}
        </p>
        <p className="text-grey-04 text-[14px] leading-[22px] md:text-[16px] md:leading-[24px] font-normal text-[14px]/22[px]  max-w-[220px]">
          {description}
        </p>
      </div>

      {/* RIGHT ICON */}
      <img src={image} className="w-8 h-8 md:w-12 md:h-12" />
    </div>
  );
};
export default StatsCard;
